export enum PLAN_STATUS {
  STEPS_EMPTY = -1,
  PENDING = 0,
  FINISHED = 1,
  WALKING_EXCEEDS = 2,
  NOT_FOUND_ATTRS = 3,
}
